import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import VideoPlayer from "./VideoPlayer";
import AccountDeletionForm from "./AccountDeletionForm";
import Login from "./login/Login";
import Register from "./register/Register";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/feed"
          element={
            <div style={{ height: "100%" }}>
              <VideoPlayer />
            </div>
          }
        />
        <Route
          path="/account-delete"
          element={
            <div style={{ height: "100%" }}>
              <AccountDeletionForm />
            </div>
          }
        />
        {/* <Route
          path="/login"
          element={
            <div style={{ height: "100%" }}>
              <Login />
            </div>
          }
        /> */}
        {/* <Route
          path="/register"
          element={
            <div style={{ height: "100%" }}>
              <Register />
            </div>
          }
        /> */}
      </Routes>
    </Router>
  );
};

export default App;
